import { type BundleConfig } from "@jti/fe-common";

export const getBundleConfig = (items: BundleConfig | undefined) => {
  if (!Array.isArray(items)) {
    items = [];
  }

  return {
    blocks: items.filter(({ type }) => type !== "multi"),
    sticks: items.filter(({ type }) => type === "multi"),
  };
};
